import React from 'react';

import { getUrlSync, ICoreContext } from '@msdyn365-commerce/core';

import { ICusWishlistResources } from '../../cus-wishlist.props.autogenerated';
import Button from '../../../../components/custom/button/button';
import { PAGE_NAMES } from '../../../../shared/const/page-names';
import { WishlistFallbackStateTemplate } from '../wishlist-fallback-state-template/wishlist-fallback-state-template';

interface Props {
    resources: ICusWishlistResources;
    context: ICoreContext;
}

export const WishlistLoggedOut = ({ resources, context }: Props) => {
    const signInUrl = context.request.user.signInUrl;
    const exploreHref = getUrlSync(PAGE_NAMES.HOME, context.actionContext) ?? context.request.sitePath ?? '/';

    return (
        <WishlistFallbackStateTemplate
            showIcon
            heading={resources.loggedOutWishlistText}
            description={resources.loggedOutWishlistDescriptionText}
        >
            {signInUrl && (
                <Button mode='anchor' href={signInUrl}>
                    {resources.loginButtonText}
                </Button>
            )}
            <Button mode='anchor' variant='secondary' href={exploreHref}>
                {resources.emptyWishlistExploreButtonText}
            </Button>
        </WishlistFallbackStateTemplate>
    );
};
